import React from "react";
import { Link } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";

const getOffset = window.innerWidth < 1360 ? -54:0;

function About(props) {
  return (
    <div className="AboutF">
      <p>Acerca de</p>
      <LinkScroll to="about" smooth="true" duration={500} delay={100} offset={getOffset}>
        Quiénes somos
      </LinkScroll>
      <LinkScroll to="benefits" smooth="true" duration={500} delay={100} offset={getOffset}>
        Beneficios
      </LinkScroll>
      <LinkScroll to="sign-up" smooth="true" duration={500} delay={100} offset={getOffset}>
        Regístrate
      </LinkScroll>
      <LinkScroll to="how" smooth="true" duration={500} delay={100} offset={getOffset}>
        Cómo funciona
      </LinkScroll>
      <LinkScroll to="community" smooth="true" duration={500} delay={100} offset={getOffset}>
        Comunidad
      </LinkScroll>
    </div>
  );
}

export default About;
